// API base URL resolution order (lets us point the frontend to any backend without rebuilding):
// 1) window.__ENV__.REACT_APP_API_BASE (runtime, from public/env.js on the server)
// 2) REACT_APP_API_BASE baked at build time
// 3) relative path ("") for localhost development (uses CRA proxy)
// 4) window.location.origin for deployed same-host /api reverse proxy
const isBrowser = typeof window !== "undefined";
const runtimeBase = isBrowser && window.__ENV__ ? window.__ENV__.REACT_APP_API_BASE || "" : "";
const buildBase = process.env.REACT_APP_API_BASE || "";
const isLocalDevHost =
  isBrowser && ["localhost", "127.0.0.1"].includes(window.location.hostname);

function normalizeBase(base) {
  return String(base || "").trim().replace(/\/+$/, "");
}

function parseHostname(base) {
  try {
    return new URL(base).hostname.toLowerCase();
  } catch {
    return "";
  }
}

const normalizedRuntimeBase = normalizeBase(runtimeBase);
const normalizedBuildBase = normalizeBase(buildBase);
const runtimeHost = parseHostname(normalizedRuntimeBase);
const runtimeLooksRemoteInLocalDev =
  isLocalDevHost &&
  runtimeHost &&
  !["localhost", "127.0.0.1"].includes(runtimeHost);

// Ignore runtime overrides that point to a remote domain when the app runs on localhost.
// This prevents local login failures caused by production-only env.js values.
const selectedBase = runtimeLooksRemoteInLocalDev
  ? normalizedBuildBase
  : normalizedRuntimeBase || normalizedBuildBase;

export const API_BASE = selectedBase || (isLocalDevHost ? "" : window.location.origin);
